import { Zap, Sparkles, DollarSign, Search, Users, Building2, Award } from 'lucide-react';

export const SUGGESTED_QUESTIONS = [
  { icon: Zap, label: "Clean energy & precious metals", question: "How is clean energy impacting the future of precious metals?" },
  { icon: Sparkles, label: "Gold nanoparticle research", question: "What are the latest advances in gold nanoparticle catalysis?" },
  { icon: DollarSign, label: "Precious metals financing", question: "What are the key insights on precious metals financing and market trends?" },
  { icon: Search, label: "Key industry trends", question: "What are the major trends and challenges in the precious metals industry?" },
];

// People & governance discovery chips (shown on the chat welcome screen).
export const DISCOVER_QUESTIONS = [
  { icon: Users, label: "Who's on the Executive Committee?", question: "Who's on the Executive Committee?" },
  { icon: Search, label: "Find refining experts", question: "who are the refining experts" },
  { icon: Award, label: "Who is the IPMI President?", question: "who is the president" },
  { icon: Building2, label: "About the IPMI Foundation", question: "tell me about the foundation" },
];

export const DOC_CARDS_LIMIT = 6;

export const CONFERENCE_OPTIONS = [
  "IPMI Annual Conference",
  "IPMI Winter Meeting",
  "Student Awards",
  "IPMI Seminar",
  "IPMI Workshop",
  "IPMI Webinar",
  "External Publication",
  "Other",
];
